import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import {OrganizationDataModel} from '../../../models/organization/organization-data.model';
import {FeeScheduleDataModel} from '../../../models/fee-schedule/fee-schedule-data.model';
import {FeeScheduleListViewDataModel} from '../models/fee-schedule-list-view.model';
import {FeeScheduleService} from '../services/fee-schedule.service';

@Component({
  selector: 'app-edit-fee-schedule',
  templateUrl: './edit-fee-schedule.component.html',
  styleUrls: ['./edit-fee-schedule.component.css']
})
export class EditFeeScheduleComponent implements OnInit {
  feeSchedule: FeeScheduleListViewDataModel;
  feeScheduleNameBackup: string;
  feeScheduleName: string;
  isLoading: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<EditFeeScheduleComponent>,
    private feeScheduleService: FeeScheduleService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {
    this.feeSchedule = this.data.feeSchedule;
    this.feeScheduleNameBackup = this.feeSchedule.FeeScheduleName;
    this.feeScheduleName = this.feeSchedule.FeeScheduleName;
  }

  close() {
    // this.feeSchedule.FeeScheduleName = this.feeScheduleNameBackup;
    this.dialogRef.close();
  }

  save() {
    this.feeSchedule.FeeScheduleName = this.feeScheduleName;
    this.feeScheduleService.editFeeSchedule(this.feeSchedule)
      .subscribe(response => {
        this.dialogRef.close(this.feeSchedule);
      }, err => {
        this.close();
      });
  }

  cancel() {
    // this.feeSchedule.FeeScheduleName = this.feeScheduleNameBackup;
    this.dialogRef.close(false);
  }
}
